import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import { IconContainerLeft, IconContainerRight, ButtonContentRoot } from './ButtonContent.style';
import { jsx as ___EmotionJSX } from "@emotion/core";

const ButtonContent = ({
  loading,
  IconLeft,
  IconRight,
  children,
  size
}) => {
  if (loading) {
    return ___EmotionJSX(CircularProgress, {
      color: "inherit",
      size: size === 'small' ? 15 : 20
    });
  }

  return ___EmotionJSX(ButtonContentRoot, {
    hasIcon: !!IconLeft || !!IconRight
  }, IconLeft ? ___EmotionJSX(IconContainerLeft, null, ___EmotionJSX(IconLeft, null)) : null, ___EmotionJSX("span", null, children), IconRight ? ___EmotionJSX(IconContainerRight, null, ___EmotionJSX(IconRight, null)) : null);
};

ButtonContent.defaultProps = {
  IconLeft: null,
  IconRight: null
};
ButtonContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  IconLeft: PropTypes.elementType,
  IconRight: PropTypes.elementType,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['small', 'medium']).isRequired
};
export default React.memo(ButtonContent);
//# sourceMappingURL=ButtonContent.js.map